export function CheckIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M1.1665 5.83325L4.49984 9.16659L12.8332 0.833252'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
